module.exports = __webpack_public_path__ + "static/media/speakers_logos_Atal.8929853f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Atal.jpg
// module id = 263
// module chunks = 0